<template>
  <div>
    <v-card outlined text class="mb-0 mt-5">
      <v-card-text class="pb-0">
        <div class="document-content">
          <p>Please attach the following documents:</p>
          <ol>
            <li>
              Proof of income (acceptable forms of income documentation are pay
              stubs, bank statements and award letters).
            </li>
            <li>
              Current rent ledger from apartment office or property management
              company.
            </li>
            <li>If you rent from a private landlord we need a utility bill.</li>
            <li>Photo of state issued Identification or a passport,</li>
          </ol>
        </div>
      </v-card-text>
      <div class="d-flex pa-3 justify-center">
        <v-btn @click="open()" outlined color="primary"> Add Documents </v-btn>
        <input
          type="file"
          class="files"
          ref="files"
          accept="image/png, image/jpeg,.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          @change="changes"
          multiple
        />
      </div>
    </v-card>
    <div class="file-list mt-5">
      <v-card
        outlined
        class="file mr-5 mb-5"
        v-for="(file, i) in files"
        :key="i"
      >
        <v-btn
          icon
          small
          class="close error"
          v-if="!file.status"
          dark
          @click="remove(i)"
        >
          <v-icon small>mdi-close</v-icon>
        </v-btn>
        <v-btn icon small class="close success" v-else dark>
          <v-icon small>mdi-check</v-icon>
        </v-btn>
        <img v-if="isImage(file)" :src="url(file)" />
        <img v-else src="../assets/documents.jpeg" />
      </v-card>
    </div>
    <v-card outlined>
      <v-card-text>
        Note: After adding all documents click Submit. <br />
        <v-btn depressed color="green" class="mt-3" dark @click="upload()">
          Submit
        </v-btn>
      </v-card-text>
    </v-card>

    <Progress v-if="loader" :status="status" />
    <Message v-if="successDialog" />
  </div>
</template>

<script>
import axios from "axios";
import Message from "../components/DocumentMessage";
import Progress from "../components/Progress";
export default {
  components: {
    Progress,
    Message,
  },
  data() {
    return {
      files: [],
      successDialog: false,
      status: "0/0",
      loader: false,
    };
  },
  computed: {
    isUploaded() {
      let count = 0;
      this.files.forEach((item) => {
        if (item.status) count++;
      });
      return count === this.files.length && count !== 0;
    },
  },
  methods: {
    isImage(file) {
      return file.name.match(/.(jpg|jpeg|png|gif)$/i);
    },
    remove(i) {
      let check = confirm("Are you sure?");
      if (check) this.files.splice(i, 1);
    },
    open() {
      const vm = this;
      vm.$refs.files.click();
    },
    url(file) {
      return URL.createObjectURL(file);
    },
    changes(e) {
      e.target.files.forEach((file) => {
        this.files.push(file);
      });
    },
    async upload() {
      const vm = this;
      let id = vm.$route.params.id;
      let list = [];
      vm.files.forEach((file) => {
        if (!file.status) list.push(file);
      });
      if (list.length === 0) return;
      vm.status = "0/" + list.length;
      let url =
        "https://us-central1-e-analogy-279118.cloudfunctions.net/api/upload";
      if (location.hostname == "localhost") {
        url = "http://localhost:5001/e-analogy-279118/us-central1/api/upload";
      }
      vm.loader = true;
      let j = 0;
      for (var i = 0; i < vm.files.length; i++) {
        let file = vm.files[i];
        if (!file.status) {
          vm.status = j + 1 + "/" + list.length;
          j++;
          let ext = file.type.split("/")[1];
          let name = file.name.split(".")[0];
          let params = {
            id,
            ext,
            name,
          };
          var formData = new FormData();
          formData.append("file", file);
          try {
            let { data } = await axios({
              url,
              method: "post",
              params,
              data: formData,
            });
            let { status, message } = data;
            if (status) {
              file.status = true;
              vm.$set(vm.files, i, file);
            } else {
              vm.loader = false;
              vm.$root.alert(message);
              return;
            }
          } catch ({ message }) {
            vm.loader = false;
            vm.$root.alert(message);
            return;
          }
        }
      }
      vm.loader = false;
      vm.status = "0/0";
      vm.successDialog = true;
    },
  },
};
</script>

<style>
.documents .files {
  display: none;
}
.file-list {
  display: flex;
  flex-wrap: wrap;
}
.file {
  width: 150px;
  height: 150px;
}
.file img {
  width: 150px;
  height: 150px;
  padding: 10px;
  object-fit: cover;
}
.close {
  position: absolute;
  right: 5px;
  top: 5px;
}
</style>
